import { ValidatorFn, AbstractControl, FormArray } from '@angular/forms';

export function formArrayAggregatedValidation(
  property: string,
  maxValue = 100
): ValidatorFn {
  return (control: AbstractControl): { [Key: string]: any } | null => {
    if (!control || !(control instanceof FormArray)) {
      return null;
    }

    let total = 0;
    for (const fg of control.controls) {
      total += fg.value[property] || 0;
    }

    return total > maxValue ? { aggregated: true } : null;
  };
}
